import APIService from 'services/APIService'

const api = APIService()

const documentAccessAPI = {
  request: (bpId, fileIds, message) => api.post(`/building-passport/${bpId}/file-access-requests`, { fileIds, message: message || null }),
  lockedFiles: (bpId, q) => api.get(`/building-passport/${bpId}/locked-files`, { params: q ? { q } : {} }),
  list: params => api.get('/me/file-access-requests', { params }),
  summary: () => api.get('/me/file-access-requests/summary'),
  decide: (ids, decision, note) => api.post('/file-access-requests/decide', { ids, decision, note: note || null }),
  selfGrant: id => api.post(`/file-access-requests/${id}/self-grant`),
  withdraw: id => api.post(`/file-access-requests/${id}/withdraw`),
}

export const DOCUMENT_ACCESS_CHANGED = 'document-access-changed'

export const announceChange = (detail = {}) => {
  try {
    window.dispatchEvent(new CustomEvent(DOCUMENT_ACCESS_CHANGED, { detail }))
  } catch (e) {
    return undefined
  }
  return undefined
}

export default documentAccessAPI
